"use client";

import { AlertProvider, ConfirmProvider, ToastProvider } from "@dionatanbig2be/big2be-ui";
import { ToastBridge } from "@/shared/components/ToastBridge";

/**
 * Providers de feedback do big2be-ui, montados uma vez no root layout. O
 * ConfirmProvider precisa envolver TODO Modal com `isDirty` — o Modal da lib
 * chama useConfirm incondicionalmente.
 *
 * Montar AQUI (root layout), e não dentro de header/footer//um widget, também
 * é o que mantém as cores certas: o ToastProvider renderiza o viewport dos
 * toasts como IRMÃO dos children (não é portal), e os toasts são `alert-*` do
 * daisyUI — leem `--color-{info,success,warning,error}` + o par `-content` do
 * escopo em que estão. No root eles pegam os tokens do app (auditados em
 * `buildThemeVars`); debaixo de um `data-theme` de widget pegariam os tokens
 * re-escopados do header/footer. Alert e Confirm são Modal, que portaliza para
 * o <body> — mesma herança.
 */
export function UIProviders({ children }: { children: React.ReactNode }) {
    return (
        <ToastProvider>
            <ToastBridge />
            <AlertProvider>
                <ConfirmProvider>{children}</ConfirmProvider>
            </AlertProvider>
        </ToastProvider>
    );
}
